import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactTooltip from 'react-tooltip';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';
import './styles.scss';

class Finish extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.Finish.title);
  }

  render() {
    const {acesso, beneficioTitulo, beneficios} = this.props.graphql;
    return (
      <div className="div-finish">
        <div className="body">
          <div className="card">
            <img src={acesso.url_image} alt={acesso.alt_image} />
          </div>

          <div className="header">
            <div className="lg">
              <p>Proposta enviada com sucesso. </p>
            </div>
            <div className="lg-subtitle">
              <p>Você receberá uma mensagem por SMS.</p>
            </div>
          </div>

          <div className="margin">
            <div className="cards">
              <div
                className="benefitsTitle"
                dangerouslySetInnerHTML={{__html: beneficioTitulo}}
              />
              <ul>
                {beneficios &&
                  beneficios.map((b) => {
                    return (
                      <li key={b.id}>
                        <div className="content-box">
                          <div className="content-box-img">
                            <img src={b.url_image} alt={b.alt_image} />
                          </div>
                          <div className="content-box-text">
                            <p>{b.feature}</p>
                          </div>
                          {b.description && (
                            <div className="tooltip">
                              <img
                                src="img/validation-access-code/icone-informacao.svg"
                                alt="Ícone Informação"
                                data-tip=""
                                data-for={b.id}
                              />
                              <ReactTooltip place="bottom" id={b.id}>
                                <div style={{width: '200px'}}>
                                  <p>{b.description}</p>
                                </div>
                              </ReactTooltip>
                            </div>
                          )}
                        </div>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({graphql}) => {
  return {graphql};
};

export default connect(mapStateToProps, {})(Finish);
